/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
// img
import TelegramGuideImg from '@assets/images/icon/etc_icon/telegram-guide-ico.png'
import TelegramGuide from '@views/TelegramGuide'
// css
import { TelegramGuideBtn } from '@styles/button.style'
import { useOnMount, useOnUnmount } from '@utils/reactExt'

const TelegramGuideButton: React.FC = () => {
  const { globalStore, logStore } = useRootStore()
  const [telegramWrapClassName, setTelegramWrapClassName] = useState('')
  const { body } = document
  const htmlElem = document.getElementsByTagName('html')[0]

  const scrollHandler = () => {
    if (htmlElem.scrollTop > 30 || body.scrollTop > 30) {
      setTelegramWrapClassName('close')
    } else {
      setTelegramWrapClassName('')
    }
  }

  useOnMount(()=>{
    if (isMobile) {
      window.addEventListener('scroll', scrollHandler, true)
    }
  })

  useOnUnmount(()=>{
    if (isMobile) {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  })

  const goGuide = () => {
    logStore.writeButtonLog({ pageId: 'c010', buttonId: '005' }).catch(console.error)
    globalStore.addGeneralPopupProperties(<TelegramGuide/>, '텔레그램 가이드')
  }

  return (
    <TelegramGuideBtn className={isMobile? telegramWrapClassName : 'pc-btn'} onClick={goGuide}>
      <img src={TelegramGuideImg} alt="텔레그램 적중 알림 설정"/>
      <span className="telegram-setting-txt">
        <div className="point-color--blue--light point">적중알림</div>
        설정하기
      </span>
    </TelegramGuideBtn>
  )
}

export default observer(TelegramGuideButton)
